<template>
  <div>
    <div class="text-xl font-black py-2">3. Fine & Country licensees 'annual performance indicators' set by the NAC</div>
    <div class="py-2">Please tick those that you feel you adhere to: </div>

    <!-- Sub section-->
    <div class="pt-2">
      <div v-for="(question, index) in form.questions[page][sectionStart]" :key="index">
        <review-question-component v-model="form.questions[page][sectionStart][index]" container-class="flex justify-between w-full" :showMandatory="showMandatory"></review-question-component>
        <hr class="border-b my-8" />
      </div>
    </div>

    <div class="pt-2 flex justify-between">
      <div class="flex-grow"></div>
      <div class="w-1/8 font-black text-lg px-4">Score:</div>
      <div class="w-1/8 font-black text-lg">{{ checkNumber }} / {{ form.questions[page][sectionStart].length }}</div>
      <div></div>
    </div>

  </div>
</template>

<script>
import ReviewQuestionComponent from '@/components/AnnualReview/ReviewQuestionComponent'
export default {
  components: { ReviewQuestionComponent },
  props: ['value', 'review', 'page', 'sectionStart', 'showMandatory'],
  data () {
    return {
      form: this.value
    }
  },
  computed: {
    checkNumber () {
      let results = this.form.questions[this.page][this.sectionStart].filter(function (question) {
        return question.result !== null && question.result !== false && question.result !== 0
      })
      return results.length ? results.length : '0'
    }
  },
  mounted () {
  }
}
</script>
